import { Card } from "@/components/ui/card";

export default function SummaryHeader({ summary, building }) {
  if (!summary) return null;
  const isCommercial = summary.kind === "commercial_plaza";
  const stats = isCommercial
    ? [
        { label: "STOREFRONTS", value: summary.commercial_units },
        { label: "FLOORS", value: summary.floors },
        { label: "CONTAINERS", value: summary.containers_40ft },
        { label: "FOOTPRINT", value: `${summary.footprint_sf.toLocaleString()} SF` },
        { label: "WINGS", value: summary.wings },
      ]
    : [
        { label: "RESIDENTIAL UNITS", value: summary.residential_units },
        { label: "FLOORS", value: summary.floors },
        { label: "CONTAINERS", value: summary.containers_40ft },
        { label: "LIVING SF", value: `${summary.living_sf.toLocaleString()} SF` },
        { label: "WINGS / STAIRS", value: `${summary.wings} / ${summary.stairwells}` },
      ];
  return (
    <Card data-testid="summary-header" className="bg-[#0f172a] border-[#1f2937] p-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {stats.map((s) => (
          <div data-testid={`stat-${s.label.toLowerCase().replace(/\s+|\//g, "-")}`} key={s.label}>
            <div className="text-[10px] tracking-[0.3em] text-[#5b6776]">{s.label}</div>
            <div className="text-2xl font-semibold text-amber-300 mt-1">{s.value}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}
